import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, viewChild } from '@angular/core';
import { WjFlexGrid, WjGridModule } from '@mescius/wijmo.angular2.grid';
import { ColumnPicker } from '../lib/ColumnPicker';
import { WjInputModule } from '@mescius/wijmo.angular2.input';
import { Menu } from '@mescius/wijmo.input';
import { CellType } from '@mescius/wijmo.grid';
import { ExcelUtils } from '../lib/Excel';
import Worksheet = Excel.Worksheet;

export interface MenuItem {
    header?: string;
    cmd?: string;
    items?: MenuItem[];
}

interface WorksheetSummary {
    name: string;
    position: number;
    visibility: boolean;
    usedRange: string;
}

@Component({
    selector: 'app-worksheets-list',
    templateUrl: './worksheets-list.component.html',
    styleUrls: ['./worksheets-list.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjInputModule,
        WjGridModule,
    ],
    standalone: true
})
export class WorksheetsListComponent implements OnInit {

    sheets: Excel.Worksheet[] = [];
    grid = viewChild.required<WjFlexGrid>('grid');

    ctxMenu: MenuItem[] = [
        { header: '<i class="fas fa-refresh"></i> ABC', cmd: 'abc' },
        { header: '<i class="fas fa-question"></i> DEF', cmd: 'def' },
        { header: '<i class="fas fa-question"></i> GHI',
            items: [
                { header: '<i class="fas fa-question"></i> GHI', cmd: 'ghi' },
                { header: '<i class="fas fa-question"></i> JKL', cmd: 'jkl' },
            ]
        },
    ];

    itemMenu = new Menu(document.createElement('div'), {
        displayMemberPath: 'header',
        selectedValuePath: 'cmd',
        closeOnLeave: true,
        subItemsPath: 'items',
        itemsSource: this.ctxMenu,
        command: {
            executeCommand: this.onCommand.bind(this),
            // canExecuteCommand: this.canExecuteCommand.bind(this),
        }
    });

    constructor(private el: ElementRef<HTMLElement>) { }

    async ngOnInit(){
        await this.listWorksheets()
        ColumnPicker.createColumnPicker(this.el.nativeElement, this.grid());
    }

    onCommand() {
        const event = this.itemMenu;
        console.log(event.selectedValue);
    }

    async listWorksheets() {
        await ExcelUtils.run(async context => {
            context.workbook.worksheets.load();
            await context.sync();
            this.sheets = context.workbook.worksheets.items;
            this.grid().itemsSource = this.sheets;
        });
    }

    async showSheet() {
        const sheet = this.grid().selectedRows[0]?.dataItem as Worksheet;
        await ExcelUtils.run(async ctx => {
            const worksheet = ctx.workbook.worksheets.getItem(sheet.name);
            worksheet.visibility = 'Visible';
            worksheet.activate();
        });
    }

    disabled(): boolean | null {
        if (this.grid().selectedRows?.length ?? 0 > 0) {
            return null;
        } else {
            return true;
        }
    }

    showContextMenu(e: MouseEvent) {
        e.preventDefault();
        const ht = this.grid().hitTest(e.pageX, e.pageY);
        switch (ht.cellType) {
            case CellType.Cell:
            case CellType.RowHeader:
            this.itemMenu.show(e);
        }
    }

    menuItemClicked(event: Menu) {
        console.log(event.selectedValue);
    }
}
